import React from "react";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { red } from "@mui/material/colors";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Stack from "@mui/material/Stack";
import AudioPlayer from "../../AudioPlayer";
//import { API_DOMAIN } from "../../../constants";
const API_DOMAIN = "https://capacitamos.com/online"

const ReadAndListenAnswer = ({
  question,
  selectedAnswer,
  showCorrect,
  showInCorrect,
  showPhare,
  setAnswer,
  courseCode
}) => {
  const handleAnswerChange = (event) => {
    if (!showCorrect && !showInCorrect) {
      setAnswer(event.target.value);
    }
  };

  return (
    <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          overflow: "auto",
          width: "100%",
          marginBottom: 2
        }}
      >
        {question.audio && (question.frase && showPhare) ? (
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <CardContent sx={{ flex: "1 0 auto" }}>
              <Typography
                variant="subtitle1"
                align="center"
                color={"primary"}
                sx={{ fontWeight: "bold" }}
              >
                {question.frase}
              </Typography>
            </CardContent>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Stack direction="row" spacing={1}>
                <AudioPlayer
                  audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                  key={question.audio}
                />
              </Stack>
            </Box>
          </Grid>
        ) : null}

        {question.audio && !question.imagen ? (
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Stack direction="row" spacing={1}>
                <AudioPlayer
                  audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                  key={question.audio}
                />
              </Stack>
            </Box>
          </Grid>
        ) : null}
        {question.imagen ? (
        <Grid item xs={2} sm={4} md={4}>
          <CardMedia
            component="img"
            style={{ maxWidth: 200, height: "auto", margin: "auto" }}
            image={`${API_DOMAIN}/contents/cursos/${courseCode}/img/${question.imagen}`}
            loading="lazy"
          />
        </Grid>
        ):null}
        <Grid item xs={2} sm={4} md={4}>
          <Box
            sx={{
              marginLeft: 2,
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <RadioGroup
              name="quiz"
              value={selectedAnswer}
              onChange={handleAnswerChange}
              row
              style={{ margin: "auto", flexDirection: "column" }}
            >
              {question.options.map((option, index) => (
                <FormControlLabel
                  key={`${option.id}-${option.respuesta}`}
                  value={`${option.id}-${option.respuesta}`}
                  control={
                    showCorrect && option.respuesta == 1 ? (
                      <CheckCircle color="success" />
                    ) : showInCorrect &&
                      option.respuesta == 0 &&
                      selectedAnswer == `${option.id}-${option.respuesta}` ? (
                      <CancelIcon sx={{ color: red[500] }} />
                    ) : (
                      <Radio />
                    )
                  }
                  label={option.opcion}
                />
              ))}
            </RadioGroup>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default ReadAndListenAnswer;
